<template>
  <!-- <div>im team announcement component</div> -->
  <fragment>
    <div v-if="list && list.length">
      <div
        class="card mb-3 border-0"
        :key="`v-announcement-${idx}`"
        v-for="(v, idx) in list"
      >
        <div class="card-body">
          <div class="media mb-2">
            <svg
              class="mr-2"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="24" height="24" rx="12" fill="#FA8C16" />
              <path
                d="M15.75 7.125C15.75 6.82663 15.8685 6.54048 16.0795 6.3295C16.2905 6.11853 16.5766 6 16.875 6C17.1734 6 17.4595 6.11853 17.6705 6.3295C17.8815 6.54048 18 6.82663 18 7.125V15.375C18 15.6734 17.8815 15.9595 17.6705 16.1705C17.4595 16.3815 17.1734 16.5 16.875 16.5C16.5766 16.5 16.2905 16.3815 16.0795 16.1705C15.8685 15.9595 15.75 15.6734 15.75 15.375V15.2145C14.1285 14.2837 12.3825 13.8322 10.566 13.6522L10.8698 15.6862C10.8901 15.7946 10.8864 15.9061 10.8588 16.0129C10.8312 16.1196 10.7803 16.219 10.7099 16.3038C10.6395 16.3887 10.5513 16.457 10.4515 16.5039C10.3517 16.5507 10.2428 16.575 10.1325 16.575H9.7215C9.57572 16.575 9.4331 16.5325 9.31108 16.4527C9.18907 16.3729 9.09296 16.2593 9.0345 16.1257L7.647 13.5082C7.5965 13.5074 7.546 13.5067 7.4955 13.506C7.09827 13.5021 6.71859 13.3418 6.43868 13.0599C6.15877 12.778 6.00116 12.3972 6 12V10.5C6.00134 10.1027 6.15868 9.72186 6.43812 9.43947C6.71757 9.15708 7.09675 8.99575 7.494 8.99025C8.11502 8.98183 8.73585 8.96308 9.35625 8.934C11.6385 8.8185 13.9672 8.29725 15.75 7.28475V7.125ZM16.5 7.125V15.375C16.5 15.4745 16.5395 15.5698 16.6098 15.6402C16.6802 15.7105 16.7755 15.75 16.875 15.75C16.9745 15.75 17.0698 15.7105 17.1402 15.6402C17.2105 15.5698 17.25 15.4745 17.25 15.375V7.125C17.25 7.02554 17.2105 6.93016 17.1402 6.85983C17.0698 6.78951 16.9745 6.75 16.875 6.75C16.7755 6.75 16.6802 6.78951 16.6098 6.85983C16.5395 6.93016 16.5 7.02554 16.5 7.125ZM15.75 8.1375C13.992 9.04125 11.8432 9.519 9.75 9.66225V12.837C9.885 12.8445 10.0193 12.8535 10.1528 12.864C12.0788 13.0057 13.9725 13.422 15.75 14.3587V8.1375ZM9 12.7987V9.70125C8.50215 9.71947 8.00412 9.73247 7.506 9.74025C7.30558 9.7426 7.11409 9.82352 6.97271 9.9656C6.83133 10.1077 6.75136 10.2996 6.75 10.5V12C6.75 12.4125 7.086 12.7515 7.5045 12.7567C8.0032 12.7625 8.50176 12.7765 9 12.7987V12.7987ZM8.50725 13.53L9.714 15.8077L9.7215 15.8257H10.1325L10.131 15.8152L9.79875 13.5907C9.36853 13.5648 8.93799 13.5443 8.50725 13.5292V13.53Z"
                fill="white"
              />
            </svg>

            <div class="media-body">
              <p class="mb-0 font-weight-bold">{{ v.title }}</p>
              <small class="text-secondary"
                ><timeago :datetime="v.createTime" locale="zh-CN"
              /></small>
            </div>
          </div>
          <p class="f-14" v-html="v.content"></p>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="card-body">
        <div class="media mb-2">没有群公告</div>
      </div>
    </div>
  </fragment>
  <!-- <div class="card mb-3 border-0">
            <div class="card-body">
              <div class="media mb-2">
                <svg
                  class="mr-2"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="24" height="24" rx="12" fill="#FA8C16" />
                  <path
                    d="M15.75 7.125C15.75 6.82663 15.8685 6.54048 16.0795 6.3295C16.2905 6.11853 16.5766 6 16.875 6C17.1734 6 17.4595 6.11853 17.6705 6.3295C17.8815 6.54048 18 6.82663 18 7.125V15.375C18 15.6734 17.8815 15.9595 17.6705 16.1705C17.4595 16.3815 17.1734 16.5 16.875 16.5C16.5766 16.5 16.2905 16.3815 16.0795 16.1705C15.8685 15.9595 15.75 15.6734 15.75 15.375V15.2145C14.1285 14.2837 12.3825 13.8322 10.566 13.6522L10.8698 15.6862C10.8901 15.7946 10.8864 15.9061 10.8588 16.0129C10.8312 16.1196 10.7803 16.219 10.7099 16.3038C10.6395 16.3887 10.5513 16.457 10.4515 16.5039C10.3517 16.5507 10.2428 16.575 10.1325 16.575H9.7215C9.57572 16.575 9.4331 16.5325 9.31108 16.4527C9.18907 16.3729 9.09296 16.2593 9.0345 16.1257L7.647 13.5082C7.5965 13.5074 7.546 13.5067 7.4955 13.506C7.09827 13.5021 6.71859 13.3418 6.43868 13.0599C6.15877 12.778 6.00116 12.3972 6 12V10.5C6.00134 10.1027 6.15868 9.72186 6.43812 9.43947C6.71757 9.15708 7.09675 8.99575 7.494 8.99025C8.11502 8.98183 8.73585 8.96308 9.35625 8.934C11.6385 8.8185 13.9672 8.29725 15.75 7.28475V7.125ZM16.5 7.125V15.375C16.5 15.4745 16.5395 15.5698 16.6098 15.6402C16.6802 15.7105 16.7755 15.75 16.875 15.75C16.9745 15.75 17.0698 15.7105 17.1402 15.6402C17.2105 15.5698 17.25 15.4745 17.25 15.375V7.125C17.25 7.02554 17.2105 6.93016 17.1402 6.85983C17.0698 6.78951 16.9745 6.75 16.875 6.75C16.7755 6.75 16.6802 6.78951 16.6098 6.85983C16.5395 6.93016 16.5 7.02554 16.5 7.125ZM15.75 8.1375C13.992 9.04125 11.8432 9.519 9.75 9.66225V12.837C9.885 12.8445 10.0193 12.8535 10.1528 12.864C12.0788 13.0057 13.9725 13.422 15.75 14.3587V8.1375ZM9 12.7987V9.70125C8.50215 9.71947 8.00412 9.73247 7.506 9.74025C7.30558 9.7426 7.11409 9.82352 6.97271 9.9656C6.83133 10.1077 6.75136 10.2996 6.75 10.5V12C6.75 12.4125 7.086 12.7515 7.5045 12.7567C8.0032 12.7625 8.50176 12.7765 9 12.7987V12.7987ZM8.50725 13.53L9.714 15.8077L9.7215 15.8257H10.1325L10.131 15.8152L9.79875 13.5907C9.36853 13.5648 8.93799 13.5443 8.50725 13.5292V13.53Z"
                    fill="white"
                  />
                </svg>

                <div class="media-body">
                  <p class="mb-0 font-weight-bold">公告标题</p>
                  <small class="text-secondary">11月09日 18:10</small>
                </div>
              </div>
              <p class="f-14">
                通过配置实现文字、图片实时内容安全审核，音频、视频文件离线审核；消息传输采用私有二进制加密协议、RSA+流式加密
              </p>
            </div>
          </div> -->
</template>
<script>
// import { mapGetters, mapActions } from 'vuex';
// import $ from 'jquery';

export default {
  name: 'IMTeamAnnouncementComponent',

  props: {
    list: Array,
  },

  data() {
    return {};
  },

  // computed: {
  //   ...mapGetters({
  //     imTeamAnnouncementList: 'imTeamAnnouncementList',
  //   }),
  // },

  // mounted() {},
  // created() {
  //   this._getTeamAnnouncementByTeamId();
  // },
  // methods: {
  //   ...mapActions({
  //     getTeamAnnouncementByTeamId: 'getIMTeamAnnouncementByTeamId',
  //   }),

  //   async _getTeamAnnouncementByTeamId() {
  //     console.log(this.teamId);
  //     await this.getTeamAnnouncementByTeamId(this.teamId);
  //   },
  // },
};
</script>
